import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import styled from "styled-components";

// import Colors from '../../../resource/ResourceColors.jsx';

const SideBar = styled.div`
    height: 100%;
    top: 0;
`;

export class SidebarTimeSignatureEvents extends Component {

    static propTypes = {
    }

    state = {};

    render() {
        console.log('SidebarTimeSignatureEvents', this.props);
        return <SideBar>'sidebar time signature events'</SideBar>
    }
}

export default SidebarTimeSignatureEvents;

